/**
 * 网页加水印
 *
 * @export
 * @param {*} [{
 *   container = document.body,
 *   width = '400px',
 *   height = '300px',
 *   textAlign = 'center',
 *   textBaseline = 'middle',
 *   font = "20px Microsoft Yahei",
 *   fillStyle = 'rgba(230, 230, 230, 0.8)',
 *   content = '保密水印',
 *   rotate = '10',
 *   zIndex = -1000
 * }={}]
 * @returns
 */
export function __waterDocument({
    container = document.body,
    width = '200px',
    height = '150px',
    textAlign = 'center',
    textBaseline = 'middle',
    font = "normal bold 26px EB Garamond, Noto Serif SC, serif",
    fillStyle = 'rgba(230, 230, 230, 0.8)',
    content = '保密水印',
    rotate = '10',
    zIndex = -1000
} = {}) {
    const args = arguments[0];
    const canvas = document.createElement('canvas');
    canvas.setAttribute('width', width);
    canvas.setAttribute('height', height);
    const ctx = canvas.getContext("2d");
    if (ctx === null) {
        console.error("this browser is not support canvas.");
        return;
    }
    ctx.textAlign = textAlign;
    ctx.textBaseline = textBaseline;
    ctx.font = font;
    ctx.fillStyle = fillStyle;
    ctx.rotate(Math.PI / 180 * rotate);
    ctx.fillText(content, parseFloat(width) / 2, parseFloat(height) / 2);
    const base64Url = canvas.toDataURL();
    const __wm = document.querySelector('.__wm');
    const watermarkDiv = __wm || document.createElement("div");
    const styleStr = `
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        z-index:${zIndex};
        pointer-events:none;
        background-repeat:repeat;
        background-image:url('${base64Url}')`;
    watermarkDiv.setAttribute('style', styleStr);
    watermarkDiv.classList.add('__wm');
    if (!__wm) {
        container.style.position = 'relative';
        container.insertBefore(watermarkDiv, container.firstChild);
    }
    const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    if (MutationObserver) {
        let mo = new MutationObserver(function () {
            const __wm = document.querySelector('.__wm');
            // 只在__wm元素变动才重新调用 __canvasWM
            if ((__wm && __wm.getAttribute('style') !== styleStr) || !__wm) {
                // 避免一直触发
                mo.disconnect();
                mo = null;
                __canvasWM(JSON.parse(JSON.stringify(args)));
            }
        });
        mo.observe(container, {
            attributes: true,
            subtree: true,
            childList: true
        })
    }
}

/**
*网页加水印 svg 方式
*
* @export
* @param {*} [{
*   container = document.body,
*   content = '请勿外传',
*   width = '300px',
*   height = '200px',
*   opacity = '0.2',
*   fontSize = '20px',
*   zIndex = 1000
* }={}]
*/
export function __waterDocumentSvg({
    container = document.body,
    content = '请勿外传',
    width = '300px',
    height = '200px',
    opacity = '0.2',
    fontSize = '26px',
    fontFamily= `PingFang SC`,
    fontWeight= 'bold',
    zIndex = 1000,
    opacitys = '0.8'
} = {}) {
    // font-size: ${fontSize}; 
    const args = arguments[0];
    const svgStr = `<svg 
            xmlns="http://www.w3.org/2000/svg" 
            xmlns:xlink= "http://www.w3.org/1999/xlink"
            width="100%" height="100%"
        >
            <text 
                x="50%" y="40%" dy="12px"
                text-anchor="middle"
                stroke="#000000"
                stroke-width="1"
                stroke-opacity="${opacity}"
                fill="#000000"
                style="
                    font-size: 20px; 
                    font-family: ${fontFamily};
                    opacity: ${opacity};
                "
            >
                ${content}
            </text>
            <image 
                xlink:href="${require('../assets/images/framework/login-new.png')}" 
                x="0" y="50%" height="30px" width="100%"
                style="
                    opacity: ${opacitys};
                "
            />
        </svg>`;
    const base64Url = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(svgStr)))}`;
    // const __wm = document.querySelector('.__wm');
    // const watermarkDiv = __wm || document.createElement("div");
    // if(container.querySelector('.__wm')){
    //     return 
    // }
    const __wm = container.querySelector('.__wm');
    const watermarkDiv = __wm || document.createElement("div");
    const styleStr = `
        position:fixed;
        bottom:0;
        right:0;
        width:45%;
        height:40%;
        z-index:${zIndex};
        pointer-events:none;
        background-repeat:no-repeat;
        background-image:url('${base64Url}')`;
    watermarkDiv.setAttribute('style', styleStr);
    watermarkDiv.classList.add('__wm');
    if (!__wm) {
        container.style.position = 'relative';
        container.insertBefore(watermarkDiv, container.firstChild);
    }
    const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    if (MutationObserver) {
        let mo = new MutationObserver(function () {
            const __wm = container.querySelector('.__wm');
            // 只在__wm元素变动才重新调用 __canvasWM
            if ((__wm && __wm.getAttribute('style') !== styleStr) || !__wm) {
                // 避免一直触发
                mo.disconnect();
                mo = null;
                __waterDocumentSvg(JSON.parse(JSON.stringify(args)));
            }
        });
        mo.observe(container, {
            attributes: true,
            subtree: true,
            childList: true
        })
    }
}

/*调用方式*/
/**
 * [container 调用方式]
 * @type {[type]}
 * __waterDocument({
    container : document.body,
    width : '200px',
    height : '150px',
    textAlign : 'center',
    textBaseline : 'middle',
    font : "20px Microsoft Yahei",
    fillStyle : 'rgba(230, 230, 230, 0.8)',
    content : '保密水印',
    rotate : '10',
    zIndex : -1000
})

__waterDocumentSvg({
    container : document.body,
    content : '请勿外传',
    width : '300px',
    height : '200px',
    opacity : '0.2',
    fontSize : '20px',
    zIndex : 1000
})
 */



// WEBPACK FOOTER //
// app/lib/waterMarking.js